export default "__VITE_ASSET__B50FZvmZ__"